import moment from 'moment';
import { SagaReturnType, call, put, takeEvery } from 'redux-saga/effects';
import { TherapistAction, dailySessionNotes } from 'src/redux/actions/constant';
import therapistSchedulingServices from 'src/services/apiServices/therapist-scheduling-services/therapist-scheduling-services';

export function* therapistAssignTaskSaga(action: any): SagaReturnType<any> {
  try {
    const response = yield call(therapistSchedulingServices.therapistAssignTask, action.payload);

    if (response?.status === 200) {
      yield put({
        type: TherapistAction.THERAPIST_TASK_ASSIGN_SUCCESS,
        payload: response.data,
        selectedTasks: action.payload?.data?.unprocessedData,
        toPick: action.payload?.toPick,
      });
      yield put({
        type: dailySessionNotes.GET_DAILY_NOTES_PRINT_STATUS_REQUEST,
        payload: {
          therapistUuid: action.payload?.meta?.providerId,
          date: action.payload?.meta?.date,
        },
      });
      if (action.payload.refresh || !response?.data?.data?.label) {
        yield put({
          type: TherapistAction.GET_ALL_THERAPIST_TASK_REQUEST,
          payload: {
            data: {
              providerId: action.payload.meta.providerId,
              localDate: action.payload?.meta.date,
              type: action.payload.meta.type,
              active: true,
              discipline: action.payload.meta.discipline,
              skill: action.payload.meta.skill,
              isV2: action.payload?.isV2,
            },
            pageNo: action.payload.meta.taskPage,
          },
        });
        yield put({
          type: TherapistAction.DISABLE_AUTO_MATCH_REQUEST,
          payload: {
            providerId: action.payload.meta.providerId,
            discipline: action.payload.meta.discipline,
            currentDate: action.payload?.meta.date,
            // action.payload?.formateDate ||
            // moment(action.payload.meta.date, 'DD-MM-YYYY').format('YYYY-MM-DD'),
          },
        });
        yield put({
          type: TherapistAction.GET_ALL_THERAPIST_DICIPLINE_TYPE_REQUEST,
          payload: {
            providerId: action.payload.meta.providerId,
            localDate: action.payload?.meta.date,
            data: { isV2: action.payload?.isV2 },
          },
        });
        yield put({
            type: TherapistAction.GET_ALL_THERAPIST_LIST_TYPE_REQUEST,
            payload: {
              pageNo: action.payload.destinationAssignPage ? action.payload.destinationAssignPage : 0,
              data: {
                providerId: action.payload.meta.providerId,
                localDate: action.payload.meta.date,
                discipline: action.payload.meta.discipline,
                sortBy: action.payload.meta.sortBy,
                searchData: action.payload?.searchData,
                filterByUuid: action.payload?.filterByUuid,
              },
            },
          });
      }
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: TherapistAction.THERAPIST_TASK_ASSIGN_FAILURE, payload: error });
  }
}

export function* therapistAssignTaskSagaWatcher() {
  yield takeEvery(TherapistAction.THERAPIST_TASK_ASSIGN_REQUEST, therapistAssignTaskSaga);
}

export default therapistAssignTaskSagaWatcher;
